import autoTable from 'jspdf-autotable';
import jsonTableRow from './rows';

// HELPERS
import title from '../../../../helpers/title';

// UTILS
import arrayTo2DArrayUTL from '../../../../../../utils/arrayTo2DArrayUTL';

const dataSourceVerificationResults = (doc, data, info, docStyles) => {
  const { Response } = data;

  // TITLE
  title(
    doc,
    docStyles,
    'Summary of Data Source Verifications and Results',
    docStyles.headers.secondary,
    docStyles.separation
  );

  // DEFAULT COLUMN
  const columns = [{ header: 'Data Sources', dataKey: 'col1' }];

  // DATA SOURCES RESULTS
  let bankCard = Response.serviceResponses['China Bank Card'];
  let idVerification = Response.serviceResponses['China ID Verification'];
  let phone = Response.serviceResponses['China Phone'];
  let passportVerification = Response.serviceResponses['China Passport Verification'];
  let driversLicense = Response.serviceResponses['China Driver License'];
  let watchlistAML = Response.serviceResponses['Watchlist AML'];

  // CHINA ID VERIFICATION
  if (idVerification) {
    columns.push({
      header: 'China ID Verification',
      dataKey: 'col2',
    });
  } else {
    idVerification = { verifications: {}, returnedData: {} };
  }

  // CHINA PHONE
  if (phone) {
    columns.push({
      header: 'China Phone',
      dataKey: 'col3',
    });
  } else {
    phone = { verifications: {}, returnedData: {} };
  }

  // GLOBAL WATCHLIST AML
  if (watchlistAML) {
    columns.push({
      header: 'Global Watchlist AML',
      dataKey: 'col4',
    });
  } else {
    watchlistAML = { verifications: {}, returnedData: {} };
  }

  //CHINA BANK CARD
  if (bankCard) {
    columns.push({
      header: 'China Bank Card',
      dataKey: 'col5',
    });
  } else {
    bankCard = { verifications: {}, returnedData: {} };
  }

  // CHINA PASSPORT VERIFICATION
  if (passportVerification) {
    columns.push({
      header: 'China Passport Verification',
      dataKey: 'col6',
    });
  } else {
    passportVerification = { verifications: {}, returnedData: {} };
  }

  // CHINA DRIVER LICENSE
  if (driversLicense) {
    columns.push({
      header: 'China Driver License',
      dataKey: 'col7',
    });
  } else {
    driversLicense = { verifications: {}, returnedData: {} };
  }

  // TABLE ROW
  const rows = jsonTableRow({
    bankCard,
    idVerification,
    phone,
    passportVerification,
    driversLicense,
    watchlistAML,
  });

  // TABLE

  // let finalY = (doc.lastAutoTable.finalY || 40) + docStyles?.tableYFromTitle;
  let finalY = (doc.lastAutoTable.finalY || 40) + docStyles?.tableYFromTitle;
  const maxAmountOfColumns = 3;
  const firstColumn = columns.shift();
  const maxColArray = arrayTo2DArrayUTL(columns, maxAmountOfColumns); // 3 COLUMNS ONLY

  maxColArray.map((col, index) => {
    col.unshift(firstColumn);

    if (index > 0) {
      finalY = (doc.lastAutoTable.finalY || 40) + docStyles.separation;
    }

    let cellWidth = docStyles.fullCellLength / 4;
    if (maxColArray[index].length === 4) {
      cellWidth = docStyles.fullCellLength / 4;
    } else if (maxColArray[index].length === 3) {
      cellWidth = docStyles.fullCellLength / 3;
    } else if (maxColArray[index].length === 2) {
      cellWidth = docStyles.fullCellLength / 2;
    }

    autoTable(doc, {
      columns: col,
      body: rows,
      didParseCell: (data) => {
        const { cell } = data;
        cell.styles.fillColor = [255, 255, 255];
        if (cell.section.includes('body') && cell.raw.length > 30) {
          cell.styles.cellPadding = { top: 15, bottom: 15 };
        }
      },
      showHead: 'firstPage',
      styles: {
        textColor: docStyles.colorText,
        font: docStyles.fontFamily.time,
        ...docStyles.tableStyles,
      },
      headStyles: {
        fontSize: docStyles.textSize,
        textColor: docStyles.colorGreen,
        fontStyle: 'normal',
      },
      columnStyles: {
        col1: {
          fontStyle: docStyles.fontFamily.time,
          textColor: docStyles.colorText,
          cellWidth: cellWidth,
        },
        col2: {
          fontStyle: docStyles.fontFamily.time,
          textColor: docStyles.colorText,
          cellWidth: cellWidth,
        },
        col3: {
          fontStyle: docStyles.fontFamily.time,
          textColor: docStyles.colorText,
          cellWidth: cellWidth,
        },
      },
      startY: finalY,
    });
    return null;
  });
};

export default dataSourceVerificationResults;
